import { render, staticRenderFns } from "./PageFormFooter.vue?vue&type=template&id=235f4b04"
import script from "./PageFormFooter.vue?vue&type=script&lang=js"
export * from "./PageFormFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports